import { Workbook } from 'exceljs';
import { downloadWorkbook } from './excelWorkbook';

/** Single-sheet .xlsx download from row objects (keys become column headers). */
export function downloadExcelSheet(
  filename: string,
  sheetName: string,
  rows: Record<string, string | number>[]
) {
  const data = rows.length > 0 ? rows : [{ note: 'No data for this period.' }];
  const workbook = new Workbook();
  const safeSheet = sheetName.replace(/[\\/*?:[\]]/g, '').slice(0, 31) || 'Report';
  const sheet = workbook.addWorksheet(safeSheet);
  const columns = Object.keys(data[0] || {});
  sheet.addRow(columns);
  data.forEach((row) => {
    sheet.addRow(columns.map((col) => row[col] ?? ''));
  });
  columns.forEach((name, index) => {
    if (/jod|fee|discount|tax|refund|charge|portion|sales/i.test(name)) {
      sheet.getColumn(index + 1).numFmt = '#,##0.000';
    }
  });
  void downloadWorkbook(workbook, filename);
}
